import { InboundBooking } from "@deliverr/inbound-client";
import pick from "lodash/pick";
import { CreateShipmentFormState, createShipmentInitialFormState as defaults } from "../../../CreateShipmentState";

type SupplierState = Pick<CreateShipmentFormState, "supplier">;

export const getSupplierState = (booking: InboundBooking): SupplierState => ({
  supplier: booking.supplier ? pick(booking.supplier, Object.keys(defaults.supplier)) : defaults.supplier,
});
